// The crew app's scale (TZ 15.3): a tablet in a holder, used with one hand in gloves.
// Text 16 px and up, touch targets 48 px and up, the main button 64 px high.

import { ConfigProvider } from 'antd';
import type { ReactNode } from 'react';

export const TOUCH = 48;
export const MAIN_BUTTON = 64;
export const TOP_BAR = 56;
export const TAB_BAR = 72;

export function CrewTheme({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 16,
          fontSizeLG: 18,
          controlHeight: TOUCH,
          controlHeightLG: MAIN_BUTTON,
          controlHeightSM: 40,
          borderRadius: 12,
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
